import React, { useEffect } from "react";
import Header from "src/Containers/Header";
import { languageJson } from "src/StringVariable";
import { Link } from "react-router-dom";
import { submitGAEvent } from "src/utils/GAEvents";
import "./TermsAndConditions.css"; // optional external styling
export default function UserAgreement() {
  useEffect(() => {
    submitGAEvent("USER AGREEMENT");
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header />
      <div className="vo-bg breadCumNewDiv">
        <div className="container-fluid row py-4 ">
          <div>
            <p className="vo-menu">
              {" "}
              <Link to="/">{languageJson.home_txt}</Link>
              <span className="text-dark">
                {" "}
                / {languageJson.footerList.userAgreement}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className="container disclaimerMainDiv">
        <div className="terms-container">
          <h1 className="user-agreement-title">User Agreement</h1>
          <p>
            This Privacy Policy applies to the Port of Oakland websites ("Port
            of Oakland," "we," "our," or "us"). We respect your privacy and are
            committed to protecting it. We provide this privacy policy (“Privacy
            Policy”) to help you ("you," "your," or "User") understand how we
            collect, use, protect, and disclose information and data when you
            use the Port of Oakland websites (the "Website"). This Privacy
            Policy also explains how you can manage the use of certain
            information we collect. By accessing, browsing, or otherwise using
            the Website, you agree to be bound by this Privacy Policy. Please
            read this Privacy Policy carefully.For more information, please
            refer to our{" "}
            <a
              href="https://www.portofoakland.com/privacy-statement"
              style={{
                color: "#0056b3",
                textDecoration: "none",
                fontWeight: "bold",
              }}
              onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
              onMouseOut={(e) => (e.target.style.textDecoration = "none")}
            >
              Privacy Statement with details
            </a>
          </p>
          <br />
          <br />

          <h1 className="user-agreement-title">Terms & Conditions – Smart Parking System (SPS)</h1>

          <p>
            These Terms & Conditions (“Terms”) govern the use of the Smart
            Parking System (“SPS”) feature within the Oakland Portal Mobile
            Application (“Mobile App”) and Oakland Portal Website (“Website”).
            By accessing, booking, or using SPS services, Licensed Motor
            Carriers (“LMCs”) and Truck Drivers (“Independent Carriers”) agree
            to these Terms in full.
          </p>

          <hr />

          {/* Section 1 */}
          <section>
            <h2 className="user-agreement-subtitle">1. Definitions</h2>
            <ul className="terms-list">
              <li>
                <strong>LMC (Licensed Motor Carrier):</strong> A registered
                carrier organization authorized to operate commercial trucking
                services and manage bookings on behalf of its fleet and
                affiliated drivers.
              </li>
              <li>
                <strong>Truck Driver / Independent Carrier:</strong> An
                individual driver, whether independent or affiliated with an
                LMC, who accesses the SPS for booking or operating under an
                active reservation.
              </li>
              <li>
                <strong>Booking:</strong> A reservation of one or more parking
                spaces made through SPS.
              </li>
              <li>
                <strong>First-Time Booking:</strong> Initial reservation made by
                a LMC or Independent Carrier through SPS, whether for a
                Daily/One-Time Booking or Recurring Booking.
              </li>
              <li>
                <strong>Daily/One-Time Booking:</strong> A non-recurring
                reservation with a defined start and end date.
              </li>
              <li>
                <strong>Recurring Booking:</strong> A subscription-based
                reservation automatically renewed monthly until canceled.
              </li>
              <li>
                <strong>Instant Approval:</strong> A booking confirmed
                immediately without internal review.
              </li>
              <li>
                <strong>Manual Approval:</strong> A booking requiring internal
                approval prior to confirmation.
              </li>
              <li>
                <strong>Security Deposit:</strong> A deposit, when required
                under the User Parking Agreement, payable by the User to the
                Port of Oakland in an amount equal to the estimated average
                monthly parking charges (if such charges exceed $10,000 per
                month).
              </li>
              <li>
                <strong>User Parking Agreement:</strong> The agreement that must
                be signed and executed by LMCs and Independent Carriers prior to
                using SPS for truck parking at the Port of Oakland.
              </li>
            </ul>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="user-agreement-subtitle">2. Eligibility & Access</h2>
            <ol>
              <li>
                SPS access is restricted to LMCs and Truck Drivers with an
                active Oakland Portal account and an executed User Parking
                Agreement.
              </li>
              <li>
                LMCs may manage bookings on behalf of their affiliated Truck
                Drivers and are responsible for ensuring driver compliance with
                these Terms.
              </li>
              <li>
                Truck Drivers must present a valid Booking number at the
                facility gate to gain entry.
              </li>
              <li>
                Each party is responsible for maintaining the confidentiality of
                their account credentials.
              </li>
              <li>
                LMCs and Truck Drivers are responsible for complying with all
                terms and conditions in the User Parking Agreement.
              </li>
            </ol>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="user-agreement-subtitle">3. Booking & Payment</h2>
            <ol>
              <li>
                Bookings may be made by LMCs on behalf of their drivers or
                directly by Truck Drivers through the Mobile App or Website.
              </li>
              <li>
                LMCs and Truck Drivers may select between Daily/One-Time
                Bookings or Recurring Bookings.
              </li>
              <li>
                Payment must be completed through the designated external
                payment processor before confirmation. Accepted methods include
                credit/debit card and ACH.
              </li>
              <li>
                Booking confirmation will be provided once payment is completed
                (Instant Approval) or after internal review (Manual Approval).
              </li>
              <li>
                Any Payment provisions herein are in addition to those in the
                User Parking Agreement.
              </li>
            </ol>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="user-agreement-subtitle">4. Refund & Cancellation Policy</h2>
            <ul className="terms-list">
              <li>
                <strong>First-Time Bookings:</strong> Cancellable within 24
                hours of the initial booking for a full refund.
              </li>
              <li>
                <strong>Daily/One-Time Bookings:</strong> May only be canceled
                within 24 hours of the initial booking. No refunds thereafter.
              </li>
              <li>
                <strong>Recurring Bookings:</strong>
                <ol className="terms-ordered">
                  <li>
                    Beginning with the second month, cancellations must be
                    submitted at least five (5) business days before the 1st of
                    the upcoming month to avoid charges.
                  </li>
                  <li>
                    “Business Days” means Monday through Friday, excluding
                    weekends. Public holidays are not excluded.
                  </li>
                  <li>
                    No partial refunds for unused days within a billing cycle.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Cancellations:</strong> Must be submitted via the Mobile
                App or Website. Exceptional cases may be handled by SPS
                Administrators.
              </li>
            </ul>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="user-agreement-subtitle">5. Security Deposits</h2>
            <p>
              If the average monthly charges for any User exceed $10,000 per
              month, a Security Deposit equal to the estimated average monthly
              charges may be required. The Port of Oakland may apply this
              deposit to cover unpaid charges. The existence of a deposit does
              not relieve the User of timely payment obligations.
            </p>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="user-agreement-subtitle">6. Reservation Approval & Waitlist</h2>
            <ol>
              <li>
                Instant Approval bookings are confirmed immediately, subject to
                payment completion.
              </li>
              <li>
                Manual Approval bookings require internal review; notifications
                will be sent via email.
              </li>
              <li>
                If no spaces are available, users may opt into a Waitlist.
                Waitlist placement does not guarantee a booking.
              </li>
            </ol>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="user-agreement-subtitle">7. Responsibilities of LMCs and Truck Drivers</h2>
            <ul className="terms-list">
              <li>
                <strong>LMCs are responsible for:</strong>
                <ul className="terms-list">
                  <li>
                    Ensuring bookings for affiliated drivers are accurate.
                  </li>
                  <li>
                    Communicating booking details (including Booking Numbers) to
                    drivers.
                  </li>
                  <li>
                    Managing cancellations or modifications for their drivers.
                  </li>
                </ul>
              </li>
              <li>
                <strong>Truck Drivers are responsible for:</strong>
                <ul className="terms-list">
                  <li>
                    Presenting valid Booking Numbers at facility entry points.
                  </li>
                  <li>
                    Adhering to booking terms (equipment length, stall quantity,
                    power requirements, etc.).
                  </li>
                  <li>
                    Canceling their own bookings (if not booked by an LMC)
                    within allowed timelines.
                  </li>
                </ul>
              </li>
            </ul>
          </section>

          {/* Section 8 */}
          <section>
            <h2 className="user-agreement-subtitle">8. Payment & Records</h2>
            <p>
              Reservation and payment records are available in the Mobile App
              dashboard for both LMCs and Truck Drivers, including booking
              number, location, payment amount, and status. Payments are final
              except as allowed under Section 4.
            </p>
          </section>

          {/* Section 9 */}
          <section>
            <h2 className="user-agreement-subtitle">9. Termination & Suspension</h2>
            <ol>
              <li>
                SPS may suspend or terminate access by an LMC or Truck Driver
                for violations of these Terms, fraudulent activity, or misuse.
              </li>
              <li>
                Refunds will not be issued for suspensions or terminations due
                to misconduct.
              </li>
            </ol>
          </section>

          {/* Section 10 */}
          <section>
            <h2 className="user-agreement-subtitle">10. Limitation of Liability</h2>
            <p>
              Neither SPS nor the Port of Oakland are liable for indirect or
              consequential damages, including lost profits, downtime, or
              unavailable parking. Parking availability is not guaranteed. Users
              agree to indemnify and hold harmless SPS, the City of Oakland, the
              Port of Oakland, and their affiliates, from any claims or damages
              resulting from use of SPS, the Mobile App, or Website. This
              indemnification continues after termination of this Agreement.
            </p>
          </section>
          <p
            style={{
              fontSize: "0.9rem",
              color: "#444",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <span style={{ fontSize: "1.1rem" }}>📅</span>
            <span>
              <strong>Effective Date:</strong> November 01, 2025
            </span>
          </p>
          <p
            style={{
              fontSize: "0.9rem",
              color: "#444",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <span style={{ fontSize: "1.1rem" }}>📅</span>
            <span>
              <strong> Date of Last Revision:</strong> November 01, 2025
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
